export const translation = {
  data: {
    getTranslations: [
      {
        english: "Hi I'm Hayley, your Virtual Leasing Agent. How can I help you?",
        spanish: "Hola, soy Hayley, tu Agente de Arrendamiento Virtual. Cómo puedo ayudarte?",
        key: "welcomeMessage",
      },
      {
        english: "Unable to load the fee calculator at this time. Please try again later.",
        spanish: "No se ha podido cargar la calculadora de tarifas en este momento. Inténtelo de nuevo más tarde.",
        key: "unableToLoadCalculator",
      },
      {
        english: "No floor plans are available for the selected filters. Please try different filters.",
        spanish: "No hay planos disponibles para los filtros seleccionados. Pruebe con otros filtros.",
        key: "noFpAvailable",
      },
      {
        english: "I now support Spanish too!",
        spanish: "¡Ahora también apoyo el español!",
        key: "supportSpanishToo",
      },
      {
        english: "Please reply me in spanish.",
        spanish: "Por favor respóndeme en español.",
        key: "replyInSpanish",
      },
      {
        english: "No",
        spanish: "No",
        key: "no",
      },
      {
        english: "Would you like to chat with a member of our team?",
        spanish: "¿Le gustaría chatear con un miembro de nuestro equipo?",
        key: "chatWithTeamMember",
      },
      {
        english: "You can continue asking me more about the property while waiting for a response from our agent",
        spanish: "Puede seguir preguntándome más sobre la propiedad mientras espera la respuesta de nuestro agente.",
        key: "continueAskingWhileWaiting",
      },
      {
        english: "Cannot find any matching units.",
        spanish: "No se encontraron unidades coincidentes.",
        key: "unitNotFound",
      },
      {
        english: "I detect Spanish in your message. Would you like to continue in Spanish?",
        spanish: "Detecto español en tu mensaje. ¿Deseas continuar en español?",
        key: "detectedSpanish",
      },
      {
        english: "No fee data available. Please try again later.",
        spanish: "No hay información disponible sobre las tarifas. Inténtelo de nuevo más tarde.",
        key: "noFeeDetailsAvailable",
      },
      {
        english: "Something went wrong.",
        spanish: "Algo salió mal.",
        key: "somethingWentWrong",
      },
      {
        english: "No units available for the selected filters",
        spanish: "No hay unidades disponibles para los filtros seleccionados",
        key: "noUnitsForFilters",
      },
      {
        english: "Image coming soon...",
        spanish: "Imagen próximamente...",
        key: "imageComingSoon",
      },
      {
        english: "Spanish is not yet available for AMA. We'll release it soon",
        spanish: "El español aún no está disponible para AMA. Lo lanzaremos pronto.",
        key: "spanishNotAvailableForAma",
      },
      {
        english: "Give feedback",
        spanish: "Dar opinion",
        key: "giveFeedback",
      },
      {
        english: "Minimize",
        spanish: "Minimizar",
        key: "minimise",
      },
      {
        english: "Back",
        spanish: "Atrás",
        key: "back",
      },
      {
        english: "Find an Apartment",
        spanish: "Encontrar un apartamento",
        key: "findApartment",
      },
      {
        english: "Schedule a Tour",
        spanish: "Programe un recorrido",
        key: "scheduleTour",
      },
      {
        english: "Videos",
        spanish: "Vídeos",
        key: "videos",
      },
      {
        english: "Community Info",
        spanish: "Información de la comunidad",
        key: "communityInfo",
      },
      {
        english: "Contact Me",
        spanish: "Contáctame",
        key: "contactMe",
      },
      {
        english: "Resident Portal",
        spanish: "Portal para residentes",
        key: "residentalPortal",
      },
      {
        english: "FAQs",
        spanish: "Preguntas frecuentes",
        key: "faqs",
      },
      {
        english: "Continue conversation",
        spanish: "continuar la conversación",
        key: "continueConversation",
      },
      {
        english: "Did any aspect of your experience with the Hayley chatbot fall short of your expectations?",
        spanish: "¿Algún aspecto de su experiencia con el chatbot de Hayley no cumplió con sus expectativas?",
        key: "chatbotExpQuestion",
      },
      {
        english: "Excellent",
        spanish: "Excelente",
        key: "excellent",
      },
      {
        english: "Needs Improvement",
        spanish: "Necesita mejorar",
        key: "needImprovement",
      },
      {
        english: "I really liked…",
        spanish: "Realmente me gustó…",
        key: "whatULike",
      },
      {
        english: "I think it would be better if…",
        spanish: "Creo que sería mejor si…",
        key: "whatNeedToImprove",
      },
      {
        english: "Submit Feedback",
        spanish: "Enviar comentarios",
        key: "submitFeedback",
      },
      {
        english: "Cancel",
        spanish: "Cancelar",
        key: "cancel",
      },
      {
        english: "Submitting…",
        spanish: "Sumisión…",
        key: "submitting",
      },
      {
        english: "Thanks for your feedback!",
        spanish: "¡Gracias por tus comentarios!",
        key: "thanksFeedback",
      },
      {
        english: "Typing{{dotLoader}}",
        spanish: "Mecanografía{{dotLoader}}",
        key: "typing",
      },
      {
        english: "How many bedrooms are you looking for?",
        spanish: "¿Cuántos dormitorios estás buscando?",
        key: "howManyBedroom",
      },
      {
        english: "Studio",
        spanish: "Estudio",
        key: "studio",
      },
      {
        english: "0 Bedroom",
        spanish: "0 Dormitorio",
        key: "0-bedrooms",
      },
      {
        english: "1 Bedroom",
        spanish: "1 Dormitorio",
        key: "1-bedroom",
      },
      {
        english: "2 Bedrooms",
        spanish: "2 Dormitorios",
        key: "2-bedrooms",
      },
      {
        english: "3 Bedrooms",
        spanish: "3 Dormitorios",
        key: "3-bedrooms",
      },
      {
        english: "Any",
        spanish: "Cualquier",
        key: "any",
      },
      {
        english: "Show all available units",
        spanish: "Mostrar todas las unidades disponibles",
        key: "showAllUnit",
      },
      {
        english: "Can you share your monthly budget with me?",
        spanish: "¿Puedes compartir tu presupuesto mensual conmigo?",
        key: "shareMonthlyBudget",
      },
      {
        english: "Custom Range",
        spanish: "Rango personalizado",
        key: "customRange",
      },
      {
        english: "Select your budget range",
        spanish: "Seleccione su rango de presupuesto",
        key: "selectBudgetRange",
      },
      {
        english: "When are you planning to move in?",
        spanish: "¿Cuándo planeas mudarte?",
        key: "planMove",
      },
      {
        english: "ASAP",
        spanish: "lo antes posible",
        key: "asap",
      },
      {
        english: "Next 30 days",
        spanish: "Los próximos 30 días",
        key: "next30Days",
      },
      {
        english: "Next 60 days",
        spanish: "Los próximos 60 días",
        key: "next60Days",
      },
      {
        english: "Filtering units…",
        spanish: "Unidades de filtrado…",
        key: "filteringUnit",
      },
      {
        english: "Loading all available units{{dotLoader}}",
        spanish: "Cargando todas las unidades disponibles{{dotLoader}}",
        key: "loadingAllUnit",
      },
      {
        english: "{{count}} Units matched your preferences",
        spanish: "{{count}} Unidades coincidieron con tus preferencias",
        key: "unitMatchPref",
      },
      {
        english: "Edit Units info Redirects to SubOrgs app",
        spanish: "Editar información de unidades Redirigir a la aplicación Sub-Orgs",
        key: "editUnitRedirectSubOrg",
      },
      {
        english: "Available now",
        spanish: "Disponible ahora",
        key: "availableNow",
      },
      {
        english: "From {{date}}",
        spanish: "Desde {{date}}",
        key: "fromDate",
      },
      {
        english: "See all {{count}} units",
        spanish: "Ver todas las {{count}} unidades",
        key: "seeAllUnit",
      },
      {
        english: "Available units",
        spanish: "Unidades disponibles",
        key: "availableUnit",
      },
      {
        english: "All",
        spanish: "Todo",
        key: "all",
      },
      {
        english: "Custom",
        spanish: "selección personalizada",
        key: "custom",
      },
      {
        english: "Bedroom",
        spanish: "Dormitorio",
        key: "bedroom",
      },
      {
        english: "Budget",
        spanish: "Presupuesto",
        key: "budget",
      },
      {
        english: "Which type of tour do you prefer?",
        spanish: "¿Qué tipo de tour prefieres?",
        key: "tourTypePref",
      },
      {
        english: "In-Person",
        spanish: "En persona",
        key: "inPersonTour",
      },
      {
        english: "Live Video",
        spanish: "Video en vivo",
        key: "liveVideoTour",
      },
      {
        english: "Self-Guided",
        spanish: "Autoguiado",
        key: "selfGuidedTour",
      },
      {
        english: "When are you available for your tour?",
        spanish: "¿Cuándo estás disponible para tu recorrido?",
        key: "whenAvailableTour",
      },
      {
        english: "Which date are you free for a live video tour?",
        spanish: "¿En qué fecha estás libre para un recorrido en video en vivo?",
        key: "whichLiveVideoTourDate",
      },
      {
        english: "Proceed to Self-Guided Tour",
        spanish: "Continuar con el recorrido autoguiado",
        key: "proceedSelfGuideTour",
      },
      {
        english: "Go Back",
        spanish: "Regresa",
        key: "goBack",
      },
      {
        english: "Available dates",
        spanish: "Fechas disponibles",
        key: "availableDates",
      },
      {
        english: "Today",
        spanish: "Hoy",
        key: "today",
      },
      {
        english: "Tomorrow",
        spanish: "Mañana",
        key: "tomorrow",
      },
      {
        english: "Select from calendar",
        spanish: "Seleccionar del calendario",
        key: "selectCalendar",
      },
      {
        english: "What time works best for you?",
        spanish: "¿A qué hora te conviene más?",
        key: "whichTimeWork",
      },
      {
        english: "Time slots available on {{date}}",
        spanish: "Horarios disponibles el {{date}}",
        key: "timeSlotAvailableDate",
      },
      {
        english: "Morning",
        spanish: "Mañana",
        key: "morning",
      },
      {
        english: "Afternoon",
        spanish: "Tarde",
        key: "afternoon",
      },
      {
        english: "Awesome, we're almost done! Just a few more details and we'll be all set.",
        spanish: "¡Genial, ya casi terminamos! Sólo unos pocos detalles más y estaremos listos.",
        key: "almostDoneFewMoreDetail",
      },
      {
        english: "First Name",
        spanish: "Nombre",
        key: "firstName",
      },
      {
        english: "Last Name",
        spanish: "Apellido",
        key: "lastName",
      },
      {
        english: "Email",
        spanish: "Correo electrónico",
        key: "email",
      },
      {
        english: "Phone Number",
        spanish: "Número de teléfono",
        key: "phoneNumber",
      },
      {
        english: "Confirming your tour{{dotLoader}}",
        spanish: "Confirmando tu recorrido{{dotLoader}}",
        key: "confirmingTour",
      },
      {
        english: "Excellent, thank you! {{fullName}} Your InPerson Tour is booked on {{date}} at {{time}}. We have sent you a confirmation email at {{email}}",
        spanish:
          "¡Excelente gracias! {{fullName}} Su recorrido en persona está reservado el {{date}} a las {{time}}.  Le hemos enviado un correo electrónico de confirmación a {{email}}",
        key: "bookedInPersonMessage",
      },
      {
        english:
          "Excellent, thank you! {{fullName}} Your Live Video Tour is booked on {{date}} at {{time}}. We have sent you a confirmation email at {{email}}",
        spanish:
          "¡Excelente gracias! {{fullName}} Su recorrido en video en vivo está reservado para el {{date}} a las {{time}}. Le hemos enviado un correo electrónico de confirmación a {{email}}",
        key: "bookedLiveVideoMessage",
      },
      {
        english:
          "Excellent, thank you! {{fullName}} Your SelfGuided Tour is booked on {{date}} at {{time}}. We have sent you a confirmation email at {{email}}",
        spanish:
          "¡Excelente gracias! {{fullName}} Su visita autoguiada está reservada el {{date}} a las {{time}}. Le hemos enviado un correo electrónico de confirmación a {{email}}",
        key: "bookedSelfGuideMessage",
      },
      {
        english: "How was the experience?",
        spanish: "¿Cómo fue la experiencia?",
        key: "howExp",
      },
      {
        english: "Skip",
        spanish: "Saltar",
        key: "skip",
      },
      {
        english: "Great! We are all done. What would you like to do next?",
        spanish: "¡Excelente! Todos hemos terminado. Que te gustaría hacer después?",
        key: "whatNext",
      },
      {
        english: "Loading photos{{dotLoader}}",
        spanish: "Cargando fotos{{dotLoader}}",
        key: "loadingPhotos",
      },
      {
        english: "Interior",
        spanish: "Interior",
        key: "interior",
      },
      {
        english: "Exterior",
        spanish: "Exterior",
        key: "exterior",
      },
      {
        english: "Amenities",
        spanish: "Comodidades",
        key: "amenities",
      },
      {
        english: "Neighborhood",
        spanish: "Vecindario",
        key: "neighborhood",
      },
      {
        english: "Edit Photos Redirects to SubOrgs app",
        spanish: "Editar fotos Redirigir a la aplicación Sub-Orgs",
        key: "editPhotoRedirectSubOrg",
      },
      {
        english: "Loading videos{{dotLoader}}",
        spanish: "Cargando vídeos{{dotLoader}}",
        key: "loadingVideos",
      },
      {
        english: "Video Tours",
        spanish: "Recorridos en vídeo",
        key: "videoTours",
      },
      {
        english: "3D Tours",
        spanish: "Recorridos 3D",
        key: "3d_videos",
      },
      {
        english: "Community",
        spanish: "Comunidad",
        key: "community_video",
      },
      {
        english: "Floor Plans",
        spanish: "Planos de planta",
        key: "floor_plan_video",
      },
      {
        english: "Video Tours",
        spanish: "Recorridos en vídeo",
        key: "pre_recorded_video",
      },
      {
        english: "3D Tours",
        spanish: "Recorridos 3D",
        key: "3d_video",
      },
      {
        english: "Edit Videos Redirects to hyTours app",
        spanish: "Editar vídeos Redirigir a la aplicación de horas",
        key: "editVideoRedirectSubOrg",
      },
      {
        english: "Invalid video URL",
        spanish: "URL de vídeo no válida",
        key: "invalidVideoUrl",
      },
      {
        english: "Loading community info{{dotLoader}}",
        spanish: "Cargando información de la comunidad{{dotLoader}}",
        key: "loadingCommunityInfo",
      },
      {
        english: "Property Overview",
        spanish: "Descripción general de la propiedad",
        key: "propertyOverview",
      },
      {
        english: "Features",
        spanish: "Características",
        key: "features",
      },
      {
        english: "Pet Policy",
        spanish: "Política de mascotas",
        key: "petPolicy",
      },
      {
        english: "Parking Policy",
        spanish: "Política de estacionamiento",
        key: "parkPolicy",
      },
      {
        english: "Office Hours",
        spanish: "Horas de oficina",
        key: "officeHours",
      },
      {
        english: "Sure, let me get a few details from you first!",
        spanish: "Claro, ¡déjame obtener algunos detalles primero!",
        key: "fewMoreDetailGet",
      },
      {
        english: "How should we contact you?",
        spanish: "¿Cómo deberíamos contactar contigo?",
        key: "howContactYou",
      },
      {
        english: "Phone call",
        spanish: "Llamada telefónica",
        key: "phoneCall",
      },
      {
        english: "Would you like to continue as",
        spanish: "¿Quieres continuar como",
        key: "wouldYouContinue",
      },
      {
        english: "Yes",
        spanish: "Sí",
        key: "yes",
      },
      {
        english: "No, continue with different {{text}}",
        spanish: "No, continuar con otro correo {{text}}",
        key: "noContinueDiff",
      },
      {
        english: "Submitting contact form{{dotLoader}}",
        spanish: "Enviando formulario de contacto{{dotLoader}}",
        key: "submitContactForm",
      },
      {
        english: "Excellent, thank you! A member of our team will reach out to you soon at {{email}}",
        spanish: "¡Excelente gracias! Un miembro de nuestro equipo se comunicará con usted pronto en {{email}}",
        key: "memberReachMailMessage",
      },
      {
        english: "Excellent, thank you! A member of our team will reach out to you soon at {{phone}} during business hours.",
        spanish: "¡Excelente gracias! Un miembro de nuestro equipo se comunicará con usted pronto al {{phone}} durante el horario comercial.",
        key: "memberReachPhoneMessage",
      },
      {
        english: "Loading options{{dotLoader}}",
        spanish: "Cargando opciones{{dotLoader}}",
        key: "loadingOptions",
      },
      {
        english: "Take me to Resident Portal",
        spanish: "Llévame al portal para residentes",
        key: "takeResidentalPortal",
      },
      {
        english: "Start Date",
        spanish: "Fecha de inicio",
        key: "startDate",
      },
      {
        english: "End Date",
        spanish: "Fecha final",
        key: "endDate",
      },
      {
        english: "Bath",
        spanish: "Baño",
        key: "bath",
      },
      {
        english: "Sq.ft",
        spanish: "Pies cuadrados",
        key: "sqft",
      },
      {
        english: "From Today",
        spanish: "A partir de hoy",
        key: "fromToday",
      },
      {
        english: "From Tomorrow",
        spanish: "Para mañana",
        key: "fromTomorrow",
      },
      {
        english: "No bedroom data",
        spanish: "Sin datos de dormitorio",
        key: "nobedData",
      },
      {
        english: "No area data",
        spanish: "Sin datos de área",
        key: "noAreaData",
      },
      {
        english: "No rent data",
        spanish: "Sin datos de alquiler",
        key: "noRentData",
      },
      {
        english: "No available date",
        spanish: "Sin fecha disponible",
        key: "noAvailDate",
      },
      {
        english: "Move in",
        spanish: "Mudarse",
        key: "moveIn",
      },
      {
        english: "Not Sure",
        spanish: "No estoy seguro",
        key: "notSure",
      },
      {
        english: "Enter your question here...",
        spanish: "Introduzca aquí su pregunta...",
        key: "enterQuesHere",
      },
      {
        english: "Sorry, selected time slot is not available.",
        spanish: "Lo sentimos, el horario seleccionado no está disponible.",
        key: "sorrySelectSlotNoAvail",
      },
      {
        english: "Oops! selected time slot is not available.",
        spanish: "¡Ups! El horario seleccionado no está disponible.",
        key: "oopsSelectSlotNoAvail",
      },
      {
        english: "Contact Not Found",
        spanish: "Contacto no encontrado",
        key: "contactNoFound",
      },
      {
        english: "No item selected",
        spanish: "Ningún artículo seleccionado",
        key: "noItemSelect",
      },
      {
        english: "I'm sorry, I don't have any units available right now. What would you like to do next?",
        spanish: "Lo siento, no tengo unidades disponibles en este momento. Que te gustaría hacer después?",
        key: "noAvailUnitWhatNext",
      },
      {
        english: "I'm sorry, I couldn't find a match for your preferences. What would you like to do next?",
        spanish: "Lo siento, no pude encontrar una coincidencia para tus preferencias. Que te gustaría hacer después?",
        key: "noMatchPrefWhatNext",
      },
      {
        english: "What is your First Name?",
        spanish: "¿Cuál es tu primer nombre?",
        key: "whatFirstName",
      },
      {
        english: "What is your Last Name?",
        spanish: "¿Cual es tu apellido?",
        key: "whatLastName",
      },
      {
        english: "Last question! What is your email address?",
        spanish: "¡Última pregunta! ¿Cuál es tu dirección de correo electrónico?",
        key: "lastQuesWhatEmail",
      },
      {
        english: "Sure, let me get a few details from you first! What is your First Name?",
        spanish: "Claro, ¡déjame darte algunos detalles primero! ¿Cuál es tu primer nombre?",
        key: "getDetailWhatFirstName",
      },
      {
        english: "What is your email address?",
        spanish: "¿Cuál es tu dirección de correo electrónico?",
        key: "whatEmail",
      },
      {
        english: "What number is the best to reach you at?",
        spanish: "¿A qué número es mejor comunicarme con usted?",
        key: "whatPhoneToConnect",
      },
      {
        english: "Oops! No photos available. What would you like to do next?",
        spanish: "¡Ups! No hay fotos disponibles. Que te gustaría hacer después?",
        key: "noPhotoWhatNext",
      },
      {
        english: "Apartment Features",
        spanish: "Características del apartamento",
        key: "appartmentFeat",
      },
      {
        english: "Community Amenities",
        spanish: "Servicios comunitarios",
        key: "communityAmenities",
      },
      {
        english: "Neighborhood Information",
        spanish: "Información del barrio",
        key: "neighborhoodInfo",
      },
      {
        english: "Parking Policy Information",
        spanish: "Información sobre la política de estacionamiento",
        key: "parkPolicyInfo",
      },
      {
        english: "Pet Policy Information",
        spanish: "Información sobre la política de mascotas",
        key: "petPolicyInfo",
      },
      {
        english: "Office Hours Information",
        spanish: "Información sobre el horario de oficina",
        key: "officeHourInfo",
      },
      {
        english: "Offer Details",
        spanish: "Detalles de las oferta",
        key: "offerDetails",
      },
      {
        english: "Oops! No information available. What would you like to do next?",
        spanish: "¡Ups! No hay información disponible. Que te gustaría hacer después?",
        key: "noInfoWhatNext",
      },
      {
        english: "Oops! No videos available. What would you like to do next?",
        spanish: "¡Ups! No hay vídeos disponibles. Que te gustaría hacer después?",
        key: "noVideoWhatNext",
      },
      {
        english: "How can I help you ?",
        spanish: "Le puedo ayudar en algo ?",
        key: "howHelp",
      },
      {
        english: "Unit",
        spanish: "Unidad",
        key: "unit",
      },
      {
        english: "Bedrooms",
        spanish: "Dormitorios",
        key: "bedrooms",
      },
      {
        english: "Area",
        spanish: "Área",
        key: "area",
      },
      {
        english: "Price",
        spanish: "Precio",
        key: "price",
      },
      {
        english: "Availability",
        spanish: "Disponibilidad",
        key: "availability",
      },
      {
        english: "This is helpful",
        spanish: "Esto es útil",
        key: "thisHelpful",
      },
      {
        english: "This is not helpful",
        spanish: "Esto no es útil",
        key: "thisNotHelpful",
      },
      {
        english: "Restart",
        spanish: "Reanudar",
        key: "restart",
      },
      {
        english: "Offer",
        spanish: "oferta",
        key: "offer",
      },
      {
        english: "Please enter a value",
        spanish: "porfavor introduzca un valor",
        key: "enterValue",
      },
      {
        english: "Please enter a valid value",
        spanish: "Por favor ingrese una cifra válida",
        key: "enterValidValue",
      },
      {
        english: "Units",
        spanish: "Unidades",
        key: "units",
      },
      {
        english: "Preferred Language",
        spanish: "Idioma preferido",
        key: "preferLang",
      },
      {
        english: "Reset",
        spanish: "Reiniciar",
        key: "reset",
      },
      {
        english: "Apply",
        spanish: "Aplicar",
        key: "apply",
      },
      {
        english: "Confirm Tour",
        spanish: "Confirmar recorrido",
        key: "confirmTour",
      },
      {
        english: "Submit",
        spanish: "Entregar",
        key: "submit",
      },
      {
        english: "Apply Now",
        spanish: "Aplica ya",
        key: "applyNow",
      },
      {
        english: "Contact Us",
        spanish: "Contacta con nosotros",
        key: "contactUs",
      },
      {
        english: "Would like to change your language?",
        spanish: "¿Le gustaría cambiar su idioma?",
        key: "changeLanguageMsg",
      },
      {
        english: "Select any option to continue",
        spanish: "Seleccione cualquier opción para continuar",
        key: "selectToContinue",
      },
      {
        english: "No, continue in English",
        spanish: "No, continúa en inglés.",
        key: "continueEnglish",
      },
      {
        english: "Yes, change to Spanish",
        spanish: "Sí, cambiar al español.",
        key: "changeSpanish",
      },
      {
        english: "No, continue in Spanish",
        spanish: "No, continúa en español.",
        key: "continueSpanish",
      },
      {
        english: "Yes, change to English",
        spanish: "Sí, cambiar al inglés.",
        key: "changeEnglish",
      },
      {
        english: "Language is set to",
        spanish: "El idioma está configurado en",
        key: "changeLangAlert1",
      },
      {
        english: "Restart chat",
        spanish: "Reiniciar chat",
        key: "restartChat",
      },
      {
        english: "To change again,",
        spanish: "Para cambiar de nuevo,",
        key: "changeLangAlert2",
      },
      {
        english: "Confirm Budget",
        spanish: "Confirmar presupuesto",
        key: "confirmBudget",
      },
      {
        english: "I’d like to receive text messages",
        spanish: "Me gustaría recibir mensajes de texto",
        key: "receiveTextMsg",
      },
      {
        english:
          "Excellent, thank you for submitting the contact form. We have sent you a confirmation email at {{email}}. A member of our team will reach out to you soon.",
        spanish:
          "Excelente, gracias por enviar el formulario de contacto. Le hemos enviado un correo electrónico de confirmación a {{email}}. Un miembro de nuestro equipo se comunicará con usted pronto.",
        key: "contactSubmitMsg",
      },
      {
        english: "Language is set to {{lang}}. To change again, {{restart}}.",
        spanish: "El idioma está configurado en {{lang}}. Para cambiar nuevamente, {{restart}}.",
        key: "changeLangAlert",
      },
      {
        english: "Main Menu",
        spanish: "Menú principal",
        key: "exploreMore",
      },
      {
        english: "Edit on Sub-Orgs app",
        spanish: "Editar en la aplicación Suborganizaciones",
        key: "editSubOrg",
      },
      {
        english: "Go full-screen",
        spanish: "Ir a pantalla completa",
        key: "goFullScreen",
      },
      {
        english: "Exit full-screen",
        spanish: "Salir de pantalla completa",
        key: "exitFullScreen",
      },
      {
        english: "Top 3 Units for you",
        spanish: "Las 3 mejores unidades para ti",
        key: "topUnitAlert",
      },
      {
        english: "Reselect",
        spanish: "Reseleccionar",
        key: "reselect",
      },
      {
        english: "Jump to latest",
        spanish: "Saltar a lo último",
        key: "jumpToLatest",
      },
      {
        english: "Total monthly leasing price",
        spanish: "Precio total mensual de arrendamiento",
        key: "totalMonthlyLeasingPrice",
      },
      {
        english: "Based on {{count}} month lease",
        spanish: "Basado en un contrato de {{count}} mes",
        key: "basedOnLeaseTerm",
      },
      {
        english: "Based on {{count}} months lease",
        spanish: "Basado en un contrato de {{count}} meses",
        key: "basedOnLeaseTerms",
      },
      {
        english: "*Applicable to Unit: {{name}}",
        spanish: "*Aplicable a la unidad: {{name}}",
        key: "applicableToUnit",
      },
      {
        english: "*Applicable to Floor Plan: {{name}}",
        spanish: "*Aplicable al plano de planta: {{name}}",
        key: "applicableToFloorPlan",
      },
      {
        english: "Required Fees - Monthly",
        spanish: "Tarifas obligatorias - Mensual",
        key: "requiredFeesMonthly",
      },
      {
        english: "Required Fees - One Time",
        spanish: "Tarifas obligatorias - Pago único",
        key: "requiredFeesOneTime",
      },
      {
        english: "Required Fees - Per Occurrence",
        spanish: "Tarifas obligatorias - Por ocurrencia",
        key: "requiredFeesPerOccurrence",
      },
      {
        english: "Optional Fees - Monthly",
        spanish: "Tarifas opcionales - Mensual",
        key: "optionalFeesMonthly",
      },
      {
        english: "Optional Fees - One Time",
        spanish: "Tarifas opcionales - Pago único",
        key: "optionalFeesOneTime",
      },
      {
        english: "Optional Fees - Per Occurrence",
        spanish: "Tarifas opcionales - Por ocurrencia",
        key: "optionalFeesPerOccurrence",
      },
      {
        english: "See all {{count}} photos",
        spanish: "Ver las {{count}} fotos",
        key: "seeAllPhotos",
      },
      {
        english: "See all {{count}} videos",
        spanish: "Ver los {{count}} vídeos",
        key: "seeAllVideos",
      },
      {
        english: "What would you like to know about this property?",
        spanish: "¿Qué le gustaría saber sobre esta propiedad?",
        key: "whatKnowAboutProperty",
      },
      {
        english: "Would you like to visit resident portal?",
        spanish: "¿Te gustaría visitar el portal para residentes?",
        key: "wouldVisitResidentPortal",
      },
      {
        english: "Retry",
        spanish: "Rever",
        key: "retry",
      },
      {
        english: "We're working on a minor issue. Please retry shortly. Thanks for your patience!",
        spanish: "Estamos trabajando en un problema menor. Vuelva a intentarlo en breve. ¡Gracias por su paciencia!",
        key: "flowErrorMessage",
      },
      {
        english:
          "Apologies, but we're currently not scheduling tours directly through the chat. But no worries, just drop us your contact details in our form below, and we'll make sure one of our agents gets in touch with you shortly.",
        spanish:
          "Disculpas, pero actualmente no estamos programando visitas directamente a través del chat. Pero no se preocupe, simplemente deje sus datos de contacto en nuestro formulario a continuación, y nos aseguraremos de que uno de nuestros agentes se comunique con usted pronto.",
        key: "noScheduleDetailGet",
      },
      {
        english: "Would you like to schedule a tour?",
        spanish: "Would you like to schedule a tour?",
        key: "wouldYouSchedule",
      },
      {
        english: "Performance Report",
        spanish: "Reporte de desempeño",
        key: "performanceReport",
      },
      {
        english: "Loading {{dotLoader}}",
        spanish: "Cargando {{dotLoader}}",
        key: "loading",
      },
      {
        english: 'Below is your \u003cspan class="hayley-font-semibold"\u003ePerfomance Report\u003c/span\u003e',
        spanish: 'A continuación se muestra su \u003cspan class="hayley-font-semibold"\u003eInforme de rendimiento\u003c/span\u003e',
        key: "performanceReportText",
      },
      {
        english: "Do I Qualify?",
        spanish: "¿Califico?",
        key: "doIQualify",
      },
      {
        english: "What is Your Budget?",
        spanish: "¿Cuál es su presupuesto?",
        key: "enterBudgetInfo",
      },
      {
        english: "Excellent, thank you! You fulfill the qualifications needed to be part of our community.",
        spanish: "¡Excelente gracias! Cumples con los requisitos necesarios para ser parte de nuestra comunidad.",
        key: "qualified",
      },
      {
        english:
          "Sorry, You don't meet the qualifications required to be part of our community. But we would like you to explore the details of our community.",
        spanish:
          "Lo sentimos, no cumples con los requisitos necesarios para ser parte de nuestra comunidad. Pero nos gustaría que explorara los detalles de nuestra comunidad.",
        key: "unqualified",
      },
      {
        english: "What aspect of your experience with the Hayley chatbot exceeded your expectations?",
        spanish: "¿Qué aspecto de tu experiencia con el chatbot de Hayley superó tus expectativas?",
        key: "chatbotLikeQuestion",
      },
      {
        english: "Explore \u0026 Contact",
        spanish: "Explorar y contactar",
        key: "exploreContact",
      },
      {
        english: "Learn More",
        spanish: "Aprende más",
        key: "learnMore",
      },
      {
        english: "View on Google Maps",
        spanish: "Ver en Google Maps",
        key: "viewOnGoogleMaps",
      },
      {
        english: "Quick Actions",
        spanish: "Acciones rápidas",
        key: "quickActions",
      },
      {
        english: "Tour Type",
        spanish: "Tipo de recorrido",
        key: "tourType",
      },
      {
        english: "Date",
        spanish: "Fecha",
        key: "date",
      },
      {
        english: "Time",
        spanish: "Tiempo",
        key: "time",
      },
      {
        english: "Special Offers",
        spanish: "Ofertas especiales",
        key: "specialOffers",
      },
      {
        english: "It looks like you already have a {{tourType}} scheduled for {{date}} at {{time}}. A confirmation email was sent to {{email}}.",
        spanish: "Parece que ya tienes un {{tourType}} programado para el {{date}} a las {{time}}. Se envió un correo electrónico de confirmación a {{email}}.",
        key: "alreadyBookedMessage",
      },
      {
        english: "Photos",
        spanish: "Fotos",
        key: "photos",
      },
      {
        english: "Awesome! We've got \u003cb\u003e{{count}} floor plans\u003c/b\u003e that align with what you're looking for.",
        spanish: "¡Impresionante! Tenemos \u003cb\u003e{{count}} planos de planta\u003c/b\u003e que se alinean con lo que estás buscando.",
        key: "floorMatchPref",
      },
      {
        english: "Unfortunately, there are no matching units available right now. However, we do have other options that you might like!",
        spanish: "Lamentablemente, no hay unidades coincidentes disponibles en este momento. Sin embargo, ¡tenemos otras opciones que podrían gustarte!",
        key: "floorMatchPref2nd",
      },
      {
        english:
          "We don’t have specific unit availability details at the moment, but here are the floor plans for this property to explore! Feel free to Contact Us or Schedule a Tour to get more details on availability.",
        spanish:
          "Lo sentimos, parece que no hay unidades disponibles en este momento. ¡Pero no te preocupes! Aquí están todos los planos de planta para que los explore.",
        key: "floorMatchPref3rd",
      },
      {
        english: "Floor Plan",
        spanish: "Plano de planta",
        key: "floorPlan",
      },
      {
        english: "Awesome! We've got \u003cb\u003e1 floor plan\u003c/b\u003e that aligns with what you're looking for.",
        spanish: "¡Impresionante! Tenemos \u003cb\u003e1 plano de planta\u003c/b\u003e que se alinea con lo que estás buscando.",
        key: "singleFloorMatchPref",
      },
      {
        english: "Contact",
        spanish: "Contacto",
        key: "contact",
      },
      {
        english: "See all",
        spanish: "Ver todo",
        key: "seeAll",
      },
      {
        english: "Unfortunately, there are no matching units available right now for the selected filters.",
        spanish: "Desafortunadamente, no hay unidades disponibles en este momento para los filtros seleccionados.",
        key: "noMatchingUnitWightFilters",
      },
      {
        english: "I'm sorry, I don't have any floor plans available right now. What would you like to do next?",
        spanish: "Lo siento, no tengo ningún plano disponible en este momento. ¿Qué te gustaría hacer a continuación?",
        key: "noAvailFloorPlanWhatNext",
      },
      {
        english: "Floor plans matched your preferences",
        spanish: "Los planos de planta coincidían con sus preferencias.",
        key: "floorPlanMatchPref",
      },
      {
        english: "Awesome! We've got \u003cb\u003e{{count}} floor plans\u003c/b\u003e available now for you.",
        spanish: "¡Impresionante! Tenemos \u003cb\u003e{{count}} planos de planta\u003c/b\u003e disponibles ahora para ti.",
        key: "genericFloorMatchPref",
      },
      {
        english: "Show all floor plans",
        spanish: "Mostrar todos los planos de planta",
        key: "showAllFloorPlan",
      },
      {
        english: "Awesome! We have \u003cb\u003e1 floor plan\u003c/b\u003e available now for you.",
        spanish: "¡Impresionante! Tenemos \u003cb\u003e1 plano de planta\u003c/b\u003e disponibles ahora para ti.",
        key: "genericSingleFloorMatchPref",
      },
      {
        english: "Write your complaint here...",
        spanish: "Escribe tu queja aquí...",
        key: "writeComplaint",
      },
      {
        english: "Complaint Description",
        spanish: "Descripción de la queja",
        key: "complaintDescription",
      },
      {
        english: "Complaint",
        spanish: "Queja",
        key: "complaint",
      },
      {
        english: "Feedback",
        spanish: "Comentario",
        key: "feedback",
      },
      {
        english:
          "While we don't have an exact match for your preferred move-in date, we do have some great options that are available around the time you're looking for. Let me know if you'd like more information!",
        spanish:
          "Aunque no tenemos una coincidencia exacta para su fecha de mudanza preferida, tenemos algunas excelentes opciones disponibles alrededor de esa fecha. ¡Házmelo saber si quieres más información!",
        key: "3a_buffer_search_no_filters_desired_move_in",
      },
      {
        english: "While we don't have an exact match for your preferred move-in date, we do have some {{bedroom}} units available around that time.",
        spanish:
          "Si bien no tenemos una coincidencia exacta para su fecha preferida de mudanza, sí tenemos algunas unidades de {{bedroom}} disponibles alrededor de esa fecha.",
        key: "3a_buffer_search_no_filters_bedroom_desired_move_in",
      },
      {
        english: "While we don't have options for your preferred move-in date, we've found units within your budget that are available around that time.",
        spanish:
          "Si bien no tenemos opciones para su fecha de mudanza preferida, hemos encontrado unidades dentro de su presupuesto que están disponibles en esa fecha.",
        key: "3a_buffer_search_no_filters_budget_desired_move_in",
      },
      {
        english:
          "While we don't have units available for your preferred move-in date, we do have {{bedroom}} units that fit your budget and are available around that time.",
        spanish:
          "Si bien no tenemos unidades disponibles para su fecha de mudanza preferida, sí tenemos unidades de {{bedroom}} que se ajustan a su presupuesto y están disponibles en ese momento.",
        key: "3a_buffer_search_no_filters_all_preferences",
      },
      {
        english: "It looks like we couldn't find apartments within your budget right now. However,  we've found some great options available  for you.",
        spanish:
          "Parece que no pudimos encontrar apartamentos dentro de su presupuesto en este momento. Sin embargo, hemos encontrado algunas excelentes opciones disponibles para usted.",
        key: "3b1_no_move_in_no_bedroom_budget",
      },
      {
        english: "It looks like we couldn't find apartments within your budget right now, but we've found options that match your move-in timeline.",
        spanish:
          "Parece que no pudimos encontrar apartamentos dentro de su presupuesto en este momento, pero encontramos opciones que coinciden con su cronograma de mudanza.",
        key: "3b1_move_in_budget_no_bedroom",
      },
      {
        english:
          "It looks like we couldn't find apartments within your budget right now, but we've found some great options available around your preferred move-in time. These units are not available on your exact move-in date, but they are available shortly before or after.",
        spanish:
          "Parece que no pudimos encontrar apartamentos dentro de su presupuesto en este momento, pero hemos encontrado algunas excelentes opciones disponibles cerca de su fecha de mudanza preferida. Estas unidades no están disponibles en su fecha exacta de mudanza, pero están disponibles poco antes o después.",
        key: "3b2_desired_move_in_no_bedroom_with_budget",
      },
      {
        english:
          "It looks like we couldn't find any {{bedroom}} apartments within your budget right now, but we've found some great units available around your preferred move-in timeline. These units are not available on your exact desired move-in date, but they are available around that time, either just before or after.",
        spanish:
          "Parece que no pudimos encontrar ningún apartamento de {{bedroom}} dentro de su presupuesto en este momento, pero encontramos algunas excelentes unidades disponibles en su cronograma de mudanza preferido. Estas unidades no están disponibles en la fecha exacta de mudanza deseada, pero están disponibles alrededor de esa hora, ya sea justo antes o después.",
        key: "3b2_desired_move_in_with_bedroom_and_budget",
      },
      {
        english:
          "It looks like we couldn't find any {{bedroom}} apartments within your budget at the moment. However, we do have other options available for your preferred move-in date.",
        spanish:
          "Parece que no pudimos encontrar ningún apartamento de {{bedroom}} dentro de su presupuesto en este momento. Sin embargo, tenemos otras opciones disponibles para su fecha de mudanza preferida.",
        key: "3c1_move_in_date_bedroom_budget",
      },
      {
        english:
          "It looks like we couldn't find any {{bedroom}} apartments within your budget at the moment. However, we do have other options available for you.",
        spanish:
          "Parece que no pudimos encontrar ningún apartamento de {{bedroom}} dentro de su presupuesto en este momento. Sin embargo, tenemos otras opciones disponibles para usted.",
        key: "3c1_no_move_in_date_bedroom_budget",
      },
      {
        english:
          "It looks like we couldn't find any {{bedroom}} apartments within your budget for your preferred move-in date. However, we do have options available near your desired timeline. These units are not available on your exact move-in date, but they are available shortly before or after.",
        spanish:
          "Parece que no pudimos encontrar ningún apartamento de {{bedroom}} dentro de su presupuesto para la fecha de mudanza preferida. Sin embargo, tenemos opciones disponibles cerca del cronograma deseado. Estas unidades no están disponibles en la fecha exacta de mudanza, pero están disponibles poco antes o después.",
        key: "3c2_move_in_date_bedroom_budget_timeline",
      },
      {
        english:
          "It looks like we couldn't find any {{bedroom}} apartments that match your specified bedroom preference at the moment. However, we do have some great options available near your preferred move-in timeline.",
        spanish:
          "Parece que no pudimos encontrar ningún apartamento de {{bedroom}} que coincida con su preferencia de dormitorio especificada en este momento. Sin embargo, tenemos algunas excelentes opciones disponibles cerca de su cronograma de mudanza preferido.",
        key: "3c2_no_buffer_search_bedroom_preference_timeline",
      },
      {
        english:
          "It looks like we couldn't find any {{bedroom}} apartments that match your specified bedroom preference at the moment. However, we do have some great options available for you.",
        spanish:
          "Parece que no pudimos encontrar ningún apartamento de {{bedroom}} que coincida con su preferencia de dormitorio especificada en este momento. Sin embargo, tenemos algunas excelentes opciones disponibles para usted.",
        key: "3c2_no_buffer_search_bedroom_preference_general",
      },
      {
        english:
          "It looks like we couldn't find any {{bedroom}} apartments that match your specified bedroom preference for your preferred time. However, we do have some great options available near your preferred move-in timeline. These units are not available on your exact move-in date, but they are available shortly before or after.",
        spanish:
          "Parece que no pudimos encontrar ningún apartamento de {{bedroom}} que coincida con su preferencia de dormitorio especificada para su horario preferido. Sin embargo, tenemos algunas excelentes opciones disponibles cerca de su cronograma de mudanza preferido. Estas unidades no están disponibles en la fecha exacta de mudanza, pero están disponibles poco antes o después.",
        key: "3c2_buffer_search_bedroom_pref_timeline_no_price",
      },
      {
        english:
          "It looks like we couldn't find any {{bedroom}} apartments within your budget for your preferred move-in date. However, we've found some excellent options that might work for you.",
        spanish:
          "Parece que no pudimos encontrar ningún apartamento de {{bedroom}} dentro de su presupuesto para la fecha de mudanza preferida. Sin embargo, hemos encontrado algunas opciones excelentes que podrían funcionar para usted.",
        key: "3d_buffer_search_bedroom_pref_move_in_price",
      },
      {
        english:
          "It looks like we couldn't find any {{bedroom}} apartments that match your specified bedroom preference at the moment. However, we do have some great options available within your budget.",
        spanish:
          "Parece que no pudimos encontrar ningún apartamento de {{bedroom}} que coincida con su preferencia de dormitorio especificada en este momento. Sin embargo, tenemos algunas excelentes opciones disponibles dentro de su presupuesto.",
        key: "3c2_no_buffer_search_bedroom_preference_budget",
      },
      {
        english: "Great news! We have {{bedroom}} units available for you.",
        spanish: "¡Buenas noticias! Tenemos unidades de {{bedroom}} disponibles para usted.",
        key: "2_bedroom_only",
      },
      {
        english: "We’ve got a range of options to fit your budget! Let me know if any of these sound like a fit.",
        spanish: "¡Tenemos una variedad de opciones que se ajustan a su presupuesto! Avíseme si alguno de estos parece adecuado.",
        key: "2_budget_only",
      },
      {
        english: "We have some great options available that align with your move-in timeline.",
        spanish: "Tenemos algunas excelentes opciones disponibles que se alinean con tu fecha de mudanza.",
        key: "2_move_in_only",
      },
      {
        english: "Great! We have {{bedroom}} units available within your budget.",
        spanish: "¡Genial! Tenemos unidades de {{bedroom}} disponibles dentro de tu presupuesto.",
        key: "2_bedroom_and_price",
      },
      {
        english: "We have {{bedroom}} units available that match your move-in timeline.",
        spanish: "Tenemos unidades de {{bedroom}} disponibles que coinciden con tu fecha de mudanza.",
        key: "2_bedroom_and_move_in",
      },
      {
        english: "Great news! We’ve found options that align with your budget and move-in timeline.",
        spanish: "¡Buenas noticias! Hemos encontrado opciones que se ajustan a tu presupuesto y fecha de mudanza.",
        key: "2_budget_and_move_in",
      },
      {
        english: "Perfect! We have {{bedroom}} units available that fit your budget and move-in timeline.",
        spanish: "¡Perfecto! Tenemos unidades de {{bedroom}} disponibles que se ajustan a tu presupuesto y fecha de mudanza.",
        key: "2_all_preferences",
      },
      {
        english: "It looks like we couldn't find {{bedroom}} apartments within your budget right now, but we do have some great options available for you.",
        spanish:
          "Parece que no pudimos encontrar apartamentos de {{bedroom}} dentro de su presupuesto en este momento, pero tenemos excelentes opciones disponibles para usted.",
        key: "3b1_no_buffer_bedroom_budget",
      },
      {
        english:
          "It looks like we couldn't find any {{bedroom}} apartments within your budget right now, but we've found options that match your move-in timeline.",
        spanish:
          "Parece que no pudimos encontrar ningún apartamento de {{bedroom}} dentro de su presupuesto en este momento, pero encontramos opciones que coinciden con su cronograma de mudanza.",
        key: "3b1_move_in_budget_bedroom",
      },
      {
        english:
          "It looks like we couldn’t find {{bedroom}} apartments that match your specified bedroom preference at the moment. However, we do have some great options available near your preferred move-in timeline and within your budget.",
        spanish:
          "Parece que no pudimos encontrar apartamentos de {{bedroom}} que coincidan con su preferencia de dormitorio especificada en este momento. Sin embargo, tenemos algunas excelentes opciones disponibles cerca de su cronograma de mudanza preferido y dentro de su presupuesto.",
        key: "3c2_no_buffer_search_bedroom_budget_timeline",
      },
      {
        english: "4 Bedrooms",
        spanish: "4 Dormitorios",
        key: "4-bedrooms",
      },
      {
        english:
          "We already have your contact information, and a member of our leasing team will be in touch with you shortly. Meanwhile, is there anything else I can help you with?",
        spanish:
          "Ya tenemos tu información de contacto y un miembro de nuestro equipo de arrendamiento se pondrá en contacto contigo en breve. Mientras tanto, ¿hay algo más en lo que pueda ayudarte?",
        key: "already_filled_contact_form",
      },
      {
        english: "Please fill out our contact form and a leasing agent will get in touch with you shortly.",
        spanish: "Complete nuestro formulario de contacto y un agente de arrendamiento se pondrá en contacto con usted en breve.",
        key: "leasing_agent_will_contact",
      },
      {
        english: "Find a Home",
        spanish: "Encontrar un hogar",
        key: "findHome",
      },
      {
        english: "Here are the photos.",
        spanish: "Aquí están las fotos.",
        key: "herePhotos",
      },
      {
        english: "Here are the videos.",
        spanish: "Aquí están los videos.",
        key: "hereVideos",
      },
      {
        english: "Here is the community info.",
        spanish: "Aquí está la información de la comunidad.",
        key: "hereCommunityInfo",
      },
      {
        english: "No photos found.",
        spanish: "No se encontraron fotos.",
        key: "noPhotosFound",
      },
      {
        english: "No Videos found.",
        spanish: "No se encontraron vídeos.",
        key: "noVideosFound",
      },
      {
        english: "Oops! No community info available. What would you like to do next?",
        spanish: "¡Uy! No hay información de la comunidad disponible. ¿Qué te gustaría hacer ahora?",
        key: "noCommunityInfoWhatNext",
      },
      {
        english: "Here are our latest special offers!",
        spanish: "¡Aquí están nuestras últimas ofertas especiales!",
        key: "hereSpecialOffers",
      },
      {
        english: "Alright! Here are the details.",
        spanish: "¡Muy bien! Aquí están los detalles.",
        key: "hereCustomBtnDetails",
      },
      {
        english: "I found your upcoming confirmed tour details.",
        spanish: "Encontré los detalles de su próxima gira confirmada.",
        key: "foundConfirmedTourDetails",
      },
      {
        english: "Reschedule Tour",
        spanish: "Reprogramar recorrido",
        key: "rescheduleTour",
      },
      {
        english: "For any change in plans, feel free to use the options below.",
        spanish: "Para cualquier cambio de planes, no dude en utilizar las opciones que aparecen a continuación.",
        key: "changeInPlan",
      },
      {
        english: "To reschedule, simply choose your new preferred time using the options below.",
        spanish: "Para reprogramar, simplemente elija su nuevo horario preferido utilizando las opciones a continuación.",
        key: "toRescheduleTourChooseOptions",
      },
      {
        english: "Would you like me to reschedule it for you?",
        spanish: "¿Quieres que lo reprograme para ti?",
        key: "rescheduleTourForMe",
      },
      {
        english: "5 Bedrooms",
        spanish: "5 Dormitorios",
        key: "5-bedrooms",
      },
      {
        english: "Would you like me to cancel it for you?",
        spanish: "¿Quieres que lo cancele por ti?",
        key: "wouldLikeToCancel",
      },
      {
        english: "Yes, cancel",
        spanish: "Sí, cancelar",
        key: "yesCancel",
      },
      {
        english: "No, don't cancel",
        spanish: "No, no canceles",
        key: "dontCancel",
      },
      {
        english: "Cancel Tour",
        spanish: "Cancelar recorrido",
        key: "cancelTour",
      },
      {
        english: "More",
        spanish: "Más",
        key: "more",
      },
      {
        english: "Close",
        spanish: "Cerca",
        key: "close",
      },
      {
        english: "Switch to english",
        spanish: "cambiar a ingles",
        key: "switchToEnglish",
      },
      {
        english: "Switch to spanish",
        spanish: "cambiar a español",
        key: "switchToSpanish",
      },
      {
        english: "Enter the amount here...",
        spanish: "Introduzca el importe aquí...",
        key: "enterAmountHere",
      },
      {
        english: "Valid phone number required",
        spanish: "Se requiere un número de teléfono válido",
        key: "validPhoneRequired",
      },
      {
        english: "Hi I'm {{name}}, your Virtual Leasing Agent. How can I help you?",
        spanish: "Hola, soy {{name}}, tu Agente de Arrendamiento Virtual. Cómo puedo ayudarte?",
        key: "welcomeMsg",
      },
      {
        english:
          "Please fill out our contact form and a leasing agent will get in touch with you shortly. You can call us directly at {{phoneNumber}} for immediate assistance.",
        spanish:
          "Complete nuestro formulario de contacto y un agente de arrendamiento se pondrá en contacto con usted en breve. Puede llamarnos directamente al {{phoneNumber}} para obtener asistencia inmediata.",
        key: "call_directly_for_assistance",
      },
      {
        english: "Message too long. Limit is {{maxLength}} characters.",
        spanish: "El mensaje es demasiado largo. El límite es de {{maxLength}} caracteres.",
        key: "errorMaxLength",
      },
      {
        english: "Please include text. Emojis alone are not supported.",
        spanish: "Por favor, incluya texto. No se admiten emojis por sí solos.",
        key: "errorEmoji",
      },
      {
        english: "Scripts or HTML are not permitted.",
        spanish: "No se permiten scripts ni HTML.",
        key: "errorHtmlInjection",
      },
      {
        english: "SQL query is not allowed.",
        spanish: "No se permite la consulta SQL.",
        key: "errorSqlInjection",
      },
      {
        english: "Input cannot be only symbols or spaces.",
        spanish: "La entrada no puede ser sólo símbolos o espacios.",
        key: "errorPureSymbol",
      },
      {
        english: "Loading calculator{{dotLoader}}",
        spanish: "Cargando calculadora{{dotLoader}}",
        key: "loadingCalculator",
      },
      {
        english: "Failed to update your selections. Please try again.",
        spanish: "No se pudieron actualizar tus selecciones. Inténtalo de nuevo.",
        key: "preferenceUpdateFailed",
      },
      {
        english: "Show All Units",
        spanish: "Mostrar todas las unidades",
        key: "showUnits",
      },
      {
        english: "Update Selections",
        spanish: "Actualizar selecciones",
        key: "updateSelections",
      },
      {
        english: "Your selections have been updated successfully.",
        spanish: "Tus selecciones se han actualizado correctamente.",
        key: "preferenceUpdatedSuccess",
      },
      {
        english: "Sure, here are all the units available in {{propertyName}}.",
        spanish: "Claro, aquí están todas las unidades disponibles en {{propertyName}}.",
        key: "sureHaveAllUnits",
      },
      {
        english: "Sure, please select your preference.",
        spanish: "Claro, por favor, seleccione su preferencia.",
        key: "sureUpdatePreference",
      },
      {
        english: "Bed Type",
        spanish: "Tipo de cama",
        key: "bedType",
      },
      {
        english: "All Bed Types",
        spanish: "Todo tipo de camas",
        key: "allBedTypes",
      },
      {
        english: "Fee Calculator",
        spanish: "Calculadora de tarifas",
        key: "feeCalculator",
      },
      {
        english: "Confirmed Tour",
        spanish: "Tour confirmado",
        key: "confirmedTourTitle",
      },
      {
        english: "Tour",
        spanish: "Recorrido",
        key: "tour",
      },
      {
        english: "{{date}} at {{time}}",
        spanish: "{{date}} a las {{time}}",
        key: "tourDateAtTime",
      },
      {
        english:
          "The selected slot ({{expiredSlotFormatted}}) is no longer available. Please select another appointment. The next available slot is {{nextAvailableSlotFormatted}}.",
        spanish:
          "El horario seleccionado ({{expiredSlotFormatted}}) ya no está disponible. Por favor, seleccione otra cita. El siguiente horario disponible es {{nextAvailableSlotFormatted}}.",
        key: "selectedSlotNotAvailable",
      },
      {
        english: "Got it! To help you better, could you please share your email or phone number?",
        spanish: "¡Entendido! Para poder ayudarte mejor, ¿podrías compartir tu correo electrónico o número de teléfono?",
        key: "pleaseShareEmailOrPhone",
      },
      {
        english:
          "I don't see a tour scheduled under you current information. Could you please share the phone number or email you used when booking?. This help me locate your tour details.",
        spanish:
          "No veo ninguna excursión programada con la información que proporcionaste. ¿Podrías compartir el número de teléfono o correo electrónico que usaste al reservar? Esto me ayudará a encontrar los detalles de tu excursión.",
        key: "donotSeeTourShareEmailOrPhone",
      },
      {
        english: "Your tour has been successfully canceled.I'll be happy to help you schedule a new one whenever you're ready!",
        spanish: "Su visita ha sido cancelada con éxito. ¡Estaré encantado de ayudarle a programar una nueva cuando esté listo!",
        key: "tourGotCanceled",
      },
      {
        english: "We do not delete your booking.",
        spanish: "No eliminamos su reserva.",
        key: "donotDeleteBooking",
      },
      {
        english: "Type your answer...",
        spanish: "Escribe tu respuesta...",
        key: "typeYourAnswer",
      },
      {
        english: "Fee summary",
        spanish: "Resumen de tarifas",
        key: "feeSummary",
      },
      {
        english: "Usage-Based",
        spanish: "Basado en el uso",
        key: "usageBased",
      },
      {
        english: "Closed",
        spanish: "Cerrado",
        key: "closed",
      },
      {
        english: "Bed",
        spanish: "Cama",
        key: "bed",
      },
      {
        english: "Min.Sq.ft",
        spanish: "Pies cuadrados mín.",
        key: "minSqFt",
      },
      {
        english: "Available from",
        spanish: "Disponible desde",
        key: "availableFrom",
      },
      {
        english: "Now",
        spanish: "Ahora",
        key: "now",
      },
      {
        english: "Inquire for Details",
        spanish: "Consultar para más detalles",
        key: "inquireDetails",
      },
      {
        english: "Base Rent",
        spanish: "Alquiler base",
        key: "baseRent",
      },
      {
        english: "Base Rent from {{amount}}",
        spanish: "Alquiler base desde {{amount}}",
        key: "baseRentFrom",
      },
      {
        english: "{{count}} available unit",
        spanish: "{{count}} unidad disponible",
        key: "availUnit",
      },
      {
        english: "{{count}} available units",
        spanish: "{{count}} unidades disponibles",
        key: "availUnits",
      },
      {
        english: "Just now",
        spanish: "Ahora mismo",
        key: "justNow",
      },
      {
        english: "Yesterday",
        spanish: "Ayer",
        key: "yesterday",
      },
      {
        english: "Estimated Rent and Fees Calculator",
        spanish: "Calculadora de alquiler y gastos estimados",
        key: "feeCalculatorHead",
      },
      {
        english: "Download PDF",
        spanish: "Descargar PDF",
        key: "downloadPdf",
      },
      {
        english: "Month",
        spanish: "Mes",
        key: "singleMonth",
      },
      {
        english: "{{count}} Months",
        spanish: "{{count}} Meses",
        key: "months",
      },
      {
        english: "Year",
        spanish: "Año",
        key: "singleYear",
      },
      {
        english: "{{count}} Years",
        spanish: "{{count}} Años",
        key: "years",
      },
      {
        english: "{{amount}} one-time fee",
        spanish: "Tarifa única de {{amount}}",
        key: "oneTimeFee",
      },
      {
        english: "{{amount}} one-time deposit",
        spanish: "Depósito único de {{amount}}",
        key: "oneTimeDeposit",
      },
      {
        english: "occurrence",
        spanish: "ocurrencia",
        key: "occurrence",
      },
      {
        english: "Other Fees (Informational)",
        spanish: "Otras tarifas (Informativas)",
        key: "otherFees",
      },
      {
        english: "Required Fees",
        spanish: "Tarifas requeridas",
        key: "requiredFees",
      },
      {
        english: "Optional Monthly",
        spanish: "Opcional Mensual",
        key: "optionalMonthly",
      },
      {
        english: "Optional Add-Ons",
        spanish: "Complementos opcionales",
        key: "optionalAddOns",
      },
      {
        english: "Lease Options",
        spanish: "Opciones de arrendamiento",
        key: "leaseOptions",
      },
      {
        english: "Lease Term",
        spanish: "Plazo de arrendamiento",
        key: "leaseTerm",
      },
      {
        english: "Move-In Date",
        spanish: "Fecha de mudanza",
        key: "moveInDate",
      },
      {
        english: "Move-Out Date",
        spanish: "Fecha de salida",
        key: "moveOutDate",
      },
      {
        english: "Move-In Date and Lease Term affect your monthly cost.",
        spanish: "La fecha de mudanza y la duración del contrato de arrendamiento afectan a su coste mensual.",
        key: "leaseTermText",
      },
      {
        english: "Applicants",
        spanish: "Solicitantes",
        key: "applicants",
      },
      {
        english: "application fee per person",
        spanish: "tarifa de solicitud por persona",
        key: "appFeePerPerson",
      },
      {
        english: "Reset All",
        spanish: "Restablecer todo",
        key: "resetAll",
      },
      {
        english: "per pet",
        spanish: "por mascota",
        key: "perPet",
      },
      {
        english: "mo",
        spanish: "mes",
        key: "perMonth",
      },
      {
        english: "Est. Monthly Cost",
        spanish: "Costo mensual estimado",
        key: "estMonthlyCost",
      },
      {
        english: "Est. Application Cost",
        spanish: "Costo estimado de la solicitud",
        key: "estApplicationCost",
      },
      {
        english: "Est. Move-In Cost",
        spanish: "Costo estimado de entrada",
        key: "estMoveInCost",
      },
      {
        english: "Est. Move-Out Cost",
        spanish: "Costo estimado de salida",
        key: "estMoveOutCost",
      },
      {
        english: "Monthly base rent for the unit.",
        spanish: "Alquiler base mensual de la unidad.",
        key: "baseRentTooltip",
      },
      {
        english: "Estimated Rent and Fees Calculator Report",
        spanish: "Informe de la calculadora de alquiler y tarifas estimadas",
        key: "feeCalculatorReportHead",
      },
      {
        english: "Report Date",
        spanish: "Fecha del informe",
        key: "reportDate",
      },
      {
        english: "Unit Information",
        spanish: "Información de la unidad",
        key: "unitInformation",
      },
      {
        english: "Unit Number",
        spanish: "Número de unidad",
        key: "unitNumber",
      },
      {
        english: "Square Footage",
        spanish: "Superficie",
        key: "squareFootage",
      },
      {
        english: "Bathrooms",
        spanish: "Baños",
        key: "bathrooms",
      },
      {
        english: "Services",
        spanish: "Servicios",
        key: "services",
      },
      {
        english: "Administrative",
        spanish: "Administrativo",
        key: "administrative",
      },
      {
        english: "This is an estimate only. Final costs may vary.",
        spanish: "Esto es solo una estimación. Los costos finales pueden variar.",
        key: "estimateOnlyNote",
      },
      {
        english: "Print / Save as PDF",
        spanish: "Imprimir / Guardar como PDF",
        key: "printSavePdf",
      },
      {
        english: "Select Date",
        spanish: "Seleccionar fecha",
        key: "selectDate",
      },
      {
        english:
          "*Est Monthly Cost includes base rent, all monthly mandatory and any user selected optional fees. Excludes variable, usage-based, and required charges due at or prior to move in or at move out. Security Deposit may change based on screening results, but total will not exceed legal maximums. Some items may be taxed under applicable law. Some fees may not apply to initial homes subject to an affordable program.",
        spanish:
          "*El costo mensual estimado incluye el alquiler base, todas las tarifas mensuales obligatorias y las tarifas opcionales seleccionadas por el usuario. Excluye los cargos variables, los basados en el uso y los cargos obligatorios que venzan en el momento de la mudanza o antes de esta, o al momento de la salida. El depósito de seguridad puede cambiar según los resultados de la selección, pero el total no excederá los máximos legales. Algunos artículos pueden estar sujetos a impuestos según la ley aplicable. Algunas tarifas pueden no aplicarse a las viviendas iniciales sujetas a un programa de vivienda asequible.",
        key: "feeCalculatorDisclaimer",
      },
      {
        english: "No units",
        spanish: "Sin unidades",
        key: "noUnits",
      },
      {
        english: "Unit Selection",
        spanish: "Selección de unidad",
        key: "unitSelection",
      },
      {
        english: "Leasing agent will contact you soon...",
        spanish: "Un agente de arrendamiento se comunicará con usted pronto...",
        key: "leasingAgentContactSoon",
      },
      {
        english: "Sorry, I can't find the link you're looking for.",
        spanish: "Lo sentimos, no encuentro el enlace que busca.",
        key: "linkNotFound",
      },
      {
        english: "Please select from the following available options:",
        spanish: "Por favor, seleccione una de las siguientes opciones disponibles:",
        key: "selectFromAvailableOptions",
      },
      {
        english: "Kindly select another type as there are no slots available.",
        spanish: "Por favor, seleccione otro tipo, ya que no hay horarios disponibles.",
        key: "noSlotsSelectAnotherType",
      },
      {
        english: "We don't have any booking for you. Please fill the form.",
        spanish: "No tenemos ninguna reserva a su nombre. Por favor, complete el formulario.",
        key: "noBookingFillForm",
      },
      {
        english:
          "I am having trouble locating your tour information. Could you please share the phone number or email you used when booking? This will help me find and cancel your tour properly.",
        spanish:
          "Tengo problemas para encontrar la información de su recorrido. ¿Podría compartir el número de teléfono o el correo electrónico que usó al reservar? Esto me ayudará a encontrar y cancelar su recorrido correctamente.",
        key: "troubleLocatingTourToCancel",
      },
      {
        english: "I still can't locate your tour. But I've saved your information and will ask a team member to follow up shortly.",
        spanish: "Todavía no encuentro su recorrido. Pero he guardado su información y pediré a un miembro del equipo que le contacte en breve.",
        key: "cannotLocateTourSavedInfo",
      },
      {
        english: "We have successfully deleted your booking.",
        spanish: "Hemos eliminado su reserva correctamente.",
        key: "bookingDeletedSuccessfully",
      },
      {
        english: "You don't have a scheduled tour. Please fill the form below:",
        spanish: "No tiene ningún recorrido programado. Por favor, complete el siguiente formulario:",
        key: "noScheduledTourFillForm",
      },
      {
        english: "Your tour has been successfully scheduled. I'll be happy to help you schedule a new one whenever you're ready!",
        spanish: "Su recorrido ha sido programado con éxito. ¡Estaré encantado de ayudarle a programar uno nuevo cuando esté listo!",
        key: "tourScheduledSuccess",
      },
      {
        english: "Your tour has been successfully rescheduled. I'll be happy to help you schedule a new one whenever you're ready!",
        spanish: "Su recorrido ha sido reprogramado con éxito. ¡Estaré encantado de ayudarle a programar uno nuevo cuando esté listo!",
        key: "tourRescheduledSuccess",
      },
      {
        english: "I still don't see any tours scheduled with those details. Would you like to book a new tour now? Here are some available times:",
        spanish:
          "Todavía no veo ningún recorrido programado con esos datos. ¿Le gustaría reservar un nuevo recorrido ahora? Estos son algunos horarios disponibles:",
        key: "noToursFoundBookNew",
      },
      {
        english: "You have a tour scheduled!",
        spanish: "¡Tiene un recorrido programado!",
        key: "tourIsScheduled",
      },
      {
        english: "We found your tour.",
        spanish: "Encontramos su recorrido.",
        key: "tourFound",
      },
      {
        english: "My apologies, this chat must be conducted in English.",
        spanish: "Mis disculpas, este chat debe realizarse en inglés.",
        key: "chatMustBeEnglish",
      },
      {
        english: "Show all {{bedroomType}}",
        spanish: "Mostrar todos los {{bedroomType}}",
        key: "showAllBedroomType",
      },
      {
        english: "Ends on {{date}}",
        spanish: "Termina el {{date}}",
        key: "offerEndsOn",
      },
      {
        english: "Disclaimer:",
        spanish: "Aviso legal:",
        key: "offerDisclaimer",
      },
      {
        english: "Sure thing! Here are the details",
        spanish: "¡Por supuesto! Aquí están los detalles",
        key: "hereAreTheDetails",
      },
      {
        english: "List View",
        spanish: "Vista de lista",
        key: "listView",
      },
      {
        english: "Map View",
        spanish: "Vista de mapa",
        key: "mapView",
      },
      {
        english: "One of our agents will personally respond to your question on following contact details:",
        spanish: "Uno de nuestros agentes responderá personalmente a su pregunta en los siguientes datos de contacto:",
        key: "agentWillRespondOnContactDetails",
      },
      {
        english: "I'm sorry about that. Please fill in the details below and one of my colleagues will reach out with a response.",
        spanish: "Lamento lo ocurrido. Por favor, complete los datos a continuación y uno de mis colegas se comunicará con una respuesta.",
        key: "sorryFillDetailsColleagueRespond",
      },
      {
        english: "Please fill in the details below and I will get you in touch with the right person.",
        spanish: "Por favor, complete los datos a continuación y le pondré en contacto con la persona adecuada.",
        key: "fillDetailsToContactRightPerson",
      },
    ],
  },
};
